/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { CountryDto } from './countryDto';
import type { EtiologyTypeDto } from './etiologyTypeDto';
import type { EtiologicalAgentDto } from './etiologicalAgentDto';
import type { FamilyDto } from './familyDto';
import type { SampleTypeDto } from './sampleTypeDto';
import type { SubCategoryDto } from './subCategoryDto';
import type { WahisEtiologicalAgentDto } from './wahisEtiologicalAgentDto';
import type { RegionDto } from './regionDto';

export interface ReferentialsResponseDto {
  /** List of countries */
  countries: CountryDto[];
  /** List of etiology types */
  etiologyTypes: EtiologyTypeDto[];
  /** List of etiological agents */
  etiologicalAgents: EtiologicalAgentDto[];
  /** List of test families */
  families: FamilyDto[];
  /** List of sample types */
  sampleTypes: SampleTypeDto[];
  /** List of sub categories */
  subCategories: SubCategoryDto[];
  /** List of WAHIS etiological agents */
  wahisEtiologicalAgents: WahisEtiologicalAgentDto[];
  /** List of WAHIS regions */
  regions: RegionDto[];
}
